import Dialog from '@material-ui/core/Dialog'
import Grid from '@material-ui/core/Grid'
import Hidden from '@material-ui/core/Hidden'
import Paper from '@material-ui/core/Paper'
import { makeStyles } from '@material-ui/core/styles'
import { motion } from 'framer-motion'
import React, { useRef } from 'react'

interface Props {
  toolbar?: React.ReactChild
  list?: React.ReactChild
  details: React.ReactChild
  detailsPlaceholder?: React.ReactChild
  paperPlaceholder?: boolean
  hideDetails?: boolean
  onMountPage?: () => void
  onUnmountPage?: () => void
}

const useStyles = makeStyles((theme) => ({
  paper: {
    height: `calc(90vh - ${theme.spacing(20)}px)`,
    overflowY: 'scroll',
    '@media (min-width: 1280px)': {
      height: `calc(100vh - ${theme.spacing(20)}px)`,
    },
  },
  placeholder: {
    display: 'flex',
    justifyContent: 'center',
    alignContent: 'center',
    height: `calc(90vh - ${theme.spacing(20)}px)`,
    backgroundColor: '#ddd',
    borderRadius: theme.spacing(0.5),
    boxShadow: 'inset 0 0 10px #bbb',
    '@media (min-width: 1280px)': {
      height: `calc(100vh - ${theme.spacing(20)}px)`,
    },
  },
  toolbar: {
    marginBottom: theme.spacing(2),
  },
}))

export default function PageLayout({
  toolbar,
  list,
  details,
  detailsPlaceholder,
  paperPlaceholder,
  hideDetails,
  onMountPage,
  onUnmountPage,
}: Props) {
  const classes = useStyles()
  const isMounted = useRef(false)
  const onAnimationComplete = () => {
    if (!isMounted.current) {
      isMounted.current = true
      onMountPage && onMountPage()
    } else {
      onUnmountPage && onUnmountPage()
    }
  }

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.15 }}
      onAnimationComplete={onAnimationComplete}
    >
      <>
        {toolbar && <div className={classes.toolbar}>{toolbar}</div>}
        <Grid container spacing={2} alignItems="stretch">
          {list ? (
            <>
              <Grid item xs={12} sm={12} md={4}>
                <Paper className={classes.paper}>{list}</Paper>
              </Grid>
              <Hidden smDown>
                <Grid item xs={12} sm={12} md={8}>
                  {hideDetails ? (
                    paperPlaceholder ? (
                      <Paper className={classes.paper}>
                        {detailsPlaceholder}
                      </Paper>
                    ) : (
                      <div className={classes.placeholder}>
                        {detailsPlaceholder}
                      </div>
                    )
                  ) : (
                    <Paper className={classes.paper}>{details}</Paper>
                  )}
                </Grid>
              </Hidden>
              <Hidden mdUp>
                <Dialog fullScreen open={!hideDetails}>
                  {details}
                </Dialog>
              </Hidden>
            </>
          ) : (
            details
          )}
        </Grid>
      </>
    </motion.div>
  )
}
